import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  height: z.enum(["small", "medium", "large"]).default("medium"),
});

export const spacerField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "spacer",
  label: "Spacer",
  category: "layout",
  icon: "MoveVertical",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { height: "medium" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
